import React from "react";
import AuditHome from "./HomeAuditoria";

interface HomeAuditHistoriProps{
  is_test?: boolean;
  itemsTest?: any[];
}
export default function HomeAuditoriaHistorico({is_test,itemsTest}:HomeAuditHistoriProps) {
  return <AuditHome isHistorico={true} is_test={is_test} itemsTest={itemsTest}/>;
}
